module.exports = __webpack_public_path__ + "img/dot_chart.ff77b54c.svg";